import Controller from "@ember/controller";

export default Controller.extend({
  queryParams: ["reset"],
});
